<template>
  <div class="about">
    <h1>This is a cool about page</h1>
  </div>
</template>
